import { Star, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Seller {
  id: string;
  name: string;
  image_url: string | null;
  rating: number;
  address: string;
}

interface SellerCardProps {
  seller: Seller;
}

export const SellerCard = ({ seller }: SellerCardProps) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/marketplace/vendor/${seller.id}`)}
      className="relative flex items-center gap-4 p-4 bg-card hover:bg-accent/50 transition-colors cursor-pointer rounded-lg border border-border"
    >
      <div className="w-20 h-20 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary/20">
        <img
          src={seller.image_url || "/placeholder.svg"}
          alt={seller.name}
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-xl text-foreground mb-2">
          {seller.name}
        </h3>
        
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            <span className="font-medium text-base">{seller.rating.toFixed(1)}</span>
          </div>
          
          <div className="flex items-center gap-1">
            <MapPin className="w-4 h-4" />
            <span className="truncate">{seller.address}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
